import { useState } from "react";
import { IAlarmError, IAlarmLevelError } from "../../../../models/Alarm";
import { IProjectError, ProjectForm } from "../../../../models/Project";

export const ProjectFormValidation = (project: ProjectForm) => {

    const errors: Partial<IProjectError> = {};
    if (project.name === "") {
        errors.name = "Input field is required!";
    }
        return errors
}
